import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Beef Guarantee</title>
                    <meta name="description" content="At A&W, we’re the first and only national burger restaurant in Canada to serve beef raised without the use of hormones or steroids." />
                </Helmet>
            :
                <Helmet>
                    <title>La garantie sur notre bœuf</title>
                    <meta name="description" content="Chez A&W, nous sommes la première et la seule chaîne de burgers au pays à servir du bœuf élevé sans ajout d’hormones ou de stéroïdes." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;